/**
 * The recency/freshness of the jobs retrieved from the API, in
 * seconds. This is used as a filter to avoid fetching all jobs
 * at once.
 * @type {Readonly<string: number>}
 */
export const Recency = Object.freeze({
  EIGHT_HOURS: 8 * 3600,
  ONE_DAY: 24 * 3600,
  ONE_WEEK: 7 * 24 * 3600,
  ONE_MONTH: 30 * 24 * 3600,
  UNSET: -1,
});

/**
 * Refresh rate of the results in the job inventory table, in milliseconds.
 * @type {Readonly<string: number>}
 */
export const RefreshRate = Object.freeze({
  FIVE_MINUTES: 5 * 60 * 1000,
  ONE_MINUTE: 60 * 1000,
  THIRTY_SECONDS: 30 * 1000,
});
